module.exports = __webpack_public_path__ + "static/media/Splash_BG@3x.8c694a4e.jpg";